type Action = { type: 'INPUT_CHANGE'; input: { name: string; value: any } };

export interface CampanhaContextProps {
  currentFilters: filters | undefined;
  setCurrentFilters: (f: filters) => void;
  setRefreshList: (b: boolean) => void;
  refreshList: boolean;
  setCurrentPage: (f: number) => void;
  currentPage: number;
  setIsLoading: (b: boolean) => void;
  isLoading: boolean;
  setPage: (b: number) => void;
  page: number;
  filterOpened: boolean;
  setFilterOpened: (b: boolean) => void;
  appliedFilters: any;
  setAppliedFilters: (o: any) => void;
  searchName: string;
  setSearchName: (s: string) => void;
  formCampanhaValues: any;
  formCampanhaErrors: any;
  setFormCampanhaErrors: (o: any) => void;
  defaultFileModalOpen: boolean;
  setDefaultFileModalOpen: (b: boolean) => void;
  dispatch: React.Dispatch<Action>;
}

export interface CampanhaTableContextProps {
  anchorEl: any;
  open: boolean;
  selected: campanha | undefined;
  setAnchorEl: (anchor: any) => void;
  setOpen: (open: boolean) => void;
  setSelected: (selected: campanha) => void;
}

export interface CampanhaHookProps {

}
export interface campanha {
  'data-fim': string;
  'data-inicio': string;
  'nome-campanha': string;
  'tipo-campanha': string;
  'grau-ensino': string;
  'quantidade-publico': number;
  status: 'Em andamento' | 'Finalizada';
  'id-campanha': string;
}

export interface campanhaToSend {
  'data-fim': string;
  'data-inicio': string;
  'nome-campanha': string;
  'tipo-campanha': string;
  'grau-ensino': string;
}
export interface paginatedResponse {
  pagina: number;
  resultados: campanha[];
  tamanho: number;
  total_paginas: number;
  total_resultados: number;
}

export interface filters {
  grau?: string;
  status?: string;
  nome?: string;
}
export interface csvDataArray {
  data: string[][]
}

export interface selectItems {
  id: string | undefined;
  label: string | undefined;
}

export enum CampanhaValues {
  NOME_CAMPANHA = 'nome-campanha',
  DATA_DE_INICIO = 'data-inicio',
  DATA_DE_FIM = 'data-fim',
  TIPO_DE_CAMPANHA = 'tipo-campanha',
  GRAU_DE_ENSINO = 'grau-ensino',
  DURACAO = 'duracao'
}

export interface CsvModel {
  Nome: string;
  ['E-mail']: string;
  Telefone: string;
  Erro: string;
}

export interface CsvRegisterProp {
  text: string;
  total: number;
}

interface ArquivoProps {
  'id-arquivo': number;
  'tipo-arquivo': string;
}

export interface RelatorioProps {
  arquivos: ArquivoProps[];
  idCampanha: number;
  linhasErro: number;
  linhasSucesso: number;
  totalLinhas: number;
}